import React from "react";
import { Helmet } from "react-helmet-async";
import { useContent } from "../context/ContentContext";

export const SITE_URL = "https://www.fletcher-stone.co.uk";
const DEFAULT_IMAGE = `${SITE_URL}/newbuild-oxshott.jpg`;
const BRAND = "Fletcher & Stone";

const Seo = ({ title, description, path = "", image }) => {
  const fullTitle = title ? `${title} | ${BRAND}` : `${BRAND} | Traditional Building Contractors`;
  const url = `${SITE_URL}${path}`;
  const img = image ? (image.startsWith("http") ? image : `${SITE_URL}${image}`) : DEFAULT_IMAGE;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={BRAND} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={img} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
};

export default Seo;

export const LocalBusinessSchema = () => {
  const { company } = useContent();
  const lines = company.addressLines || [];
  const localityRegion = (lines[1] || "").split(",").map((s) => s.trim());

  const data = {
    "@context": "https://schema.org",
    "@type": "GeneralContractor",
    name: company.name,
    legalName: company.fullName,
    description:
      "Traditional building contractors delivering fine new builds, extensions, refurbishment and heritage restoration across London, The Home Counties and The Cotswolds.",
    url: SITE_URL,
    logo: `${SITE_URL}/newbuild-oxshott.jpg`,
    image: `${SITE_URL}/newbuild-oxshott.jpg`,
    telephone: company.phone,
    email: company.email,
    priceRange: "££££",
    address: {
      "@type": "PostalAddress",
      streetAddress: lines[0] || "",
      addressLocality: localityRegion[0] || "",
      addressRegion: localityRegion[1] || "",
      postalCode: lines[2] || "",
      addressCountry: "GB",
    },
    areaServed: ["London", "The Home Counties", "The Cotswolds"],
    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
        opens: "08:00",
        closes: "17:00",
      },
    ],
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};
